import React, { FC } from "react";

interface BreadcrumbsProps {
	breadcrumbs: string[];
}

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ breadcrumbs }) => {
	if (!breadcrumbs || breadcrumbs.length === 0) {
		return null;
	}

	return (
		<div className="Breadcrumbs">
			{breadcrumbs.map((item, index) => {
				const isLast = index === breadcrumbs.length - 1;
				return (
					<span className="Breadcrumbs__item" key={index}>
						{isLast ? <strong>{item}</strong> : item}
					</span>
				);
			})}
		</div>
	);
};
